import React from 'react'
import { Icon } from '@/ui/atoms/Icon'

type UsedInProps = {
  items: Array<{ process: string; wiki: string }>
  isAlsoUsedIn?: boolean
  productGroup?: { title: string; href: string }
  showBorder?: boolean
  compact?: boolean
  className?: string
}

export const UsedIn: React.FC<UsedInProps> = ({ items, isAlsoUsedIn, productGroup, showBorder, compact, className }) => {
  if ((!items || items.length === 0) && !productGroup) return null

  const hasUsedInItems = items && items.length > 0
  const firstItem = hasUsedInItems ? items[0] : null
  const remainingCount = hasUsedInItems ? items.length - 1 : 0

  return (
    <div className={className ?? ''}>
      <div className={compact ? 'flex flex-row flex-wrap items-center gap-2' : 'flex flex-col gap-1'}>
        {hasUsedInItems && firstItem && (
          <>
            <span className="text-body-XS-regular text-blue-20">
              {isAlsoUsedIn ? 'Also used in' : 'Used in'}
            </span>
            <div className="flex flex-row flex-wrap items-center gap-2">
              <span
                className={`text-body-XS-regular text-blue-20 bg-blue-97 rounded px-2 py-1 inline-flex items-center gap-1 w-fit border transition-colors ${showBorder ? 'border-border-subtle' : 'border-transparent canhover:group-hover:border-border-subtle'}`}
              >
                {firstItem.process}
                <Icon name="arrow-right-s-line" className="h-3.5 w-3.5 shrink-0" />
                {firstItem.wiki}
              </span>
              {remainingCount > 0 && (
                <span className="text-body-XS-regular text-blue-20">
                  +{remainingCount} more
                </span>
              )}
            </div>
          </>
        )}
        {productGroup && (
          <span className={`text-body-XS-regular text-blue-20 ${compact ? '' : 'mt-2'}`}>
            Product Group: {productGroup.title}
          </span>
        )}
      </div>
    </div>
  )
}
